import {
  MyMenuAdhart,
  MyMenuAsk,
  MyMenuBjNotice,
  MyMenuBlacklist,
  MyMenuBroadcastApp,
  MyMenuBroadcastGuide,
  MyMenuBroadcastHistory,
  MyMenuBroadcastSet,
  MyMenuChannelHome,
  MyMenuCouponUp,
  MyMenuEvent,
  MyMenuExchange,
  MyMenuFanGrade,
  MyMenuFaq,
  MyMenuGiftDetail,
  MyMenuItemDetail,
  MyMenuLogout,
  MyMenuMemModify,
  MyMenuMissionlist,
  MyMenuMypage,
  MyMenuNotice,
  MyMenuPayDetail,
  MyMenuReportCenter,
  MyMenuSignature,
} from '@module/svg/icons';
import type React from 'react';

type MenuSvgMap = {
  [key: string]: React.ReactNode;
};
export const menuSvg: MenuSvgMap = {
  MyMenuChannelHome: <MyMenuChannelHome />,
  MyMenuEvent: <MyMenuEvent />,
  MyMenuNotice: <MyMenuNotice />,
  MyMenuAdhart: <MyMenuAdhart />,
  MyMenuFaq: <MyMenuFaq />,
  MyMenuBroadcastGuide: <MyMenuBroadcastGuide />,
  MyMenuAsk: <MyMenuAsk />,
  MyMenuReportCenter: <MyMenuReportCenter />,
  MyMenuBroadcastHistory: <MyMenuBroadcastHistory />,
  MyMenuBroadcastSet: <MyMenuBroadcastSet />,
  MyMenuBlacklist: <MyMenuBlacklist />,
  MyMenuFanGrade: <MyMenuFanGrade />,
  MyMenuBjNotice: <MyMenuBjNotice />,
  MyMenuExchange: <MyMenuExchange />,
  MyMenuBroadcastApp: <MyMenuBroadcastApp />,
  MyMenuLogout: <MyMenuLogout />,
  MyMenuMemModify: <MyMenuMemModify />,
  MyMenuCouponUp: <MyMenuCouponUp />,
  MyMenuSignature: <MyMenuSignature />,
  MyMenuGiftDetail: <MyMenuGiftDetail />,
  MyMenuItemDetail: <MyMenuItemDetail />,
  MyMenuPayDetail: <MyMenuPayDetail />,
  MyMenuMissionlist: <MyMenuMissionlist />,
  MyMenuMypage: <MyMenuMypage />,
};
